import axios from "axios";

type Event = {
    id: string
    name: string
}

type EventResponse = {
    ID: string
    Site: Site
    Market: Market
}
type EventsResponse = {
    events: Array<EventResponse>
}

type Site = {
    id: string
    Domain: string
}

type Market = {
    id: string
    Name: string
}

export function LoadEvents(callback: any) {
    axios
        .get<EventsResponse>('/api/v1/events')
        .then(response => {
            let events = [] as Array<Event>
            if (response.data.events) {
                response.data.events.forEach(function (event) {
                    if (event.Site) {
                        events.push({
                            id: event.ID,
                            name: "site: "+event.Site.Domain
                        })
                    }
                    if (event.Market) {
                        events.push({
                            id: event.ID,
                            name: "market: "+event.Market.Name
                        })
                    }
                })
            }

            console.log(events)

            callback(events)
        })
}